import { Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 't-llevo-dialog-header',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule
  ],
  templateUrl: './dialog-header.component.html',
  styleUrl: './dialog-header.component.scss',
})
export class DialogHeaderComponent {
  @Input({required: true}) dialogTitle!: string
  @HostBinding('attr.mat-dialog-title') attrDialogTitle = true
  @HostBinding('class.mat-mdc-dialog-title') titleClass = true
  @HostBinding('class.mdc-dialog__title') titleClass1 = true
}
